// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".counter-proposal-value{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}.counter-proposal .container{max-width:600px}.counter-proposal .btn-mobile-prev i{margin-left:5px}.counter-proposal .btn-mobile-save{margin-right:0;margin-left:0}.counter-proposal .btn-mobile-prev{margin-right:0}", ""]);
// Exports
module.exports = exports;
